const vehicleAttribute = () => import('@/pages/vehicleAttribute/index')
const stationVehicleLists = () => import('@/pages/vehicleAttribute/stationVehicleLists')
const vehicleAttrUpdate = () => import('@/pages/vehicleAttribute/vehicleAttrUpdate')
export default [
  {
    path: '/vehicleAttribute',
    name: 'vehicleAttribute',
    component: vehicleAttribute,
    meta: {
      storeKey: 'trs.inventory.index'
    }
  },
  {
    path: '/stationVehicleLists',
    name: 'stationVehicleLists',
    component: stationVehicleLists,
    meta: {}
  },
  {
    path: '/vehicleAttrUpdate',
    name: 'vehicleAttrUpdate',
    component: vehicleAttrUpdate,
    meta: {}
  }
]



// WEBPACK FOOTER //
// ./src/router/vehicleAttribute/index.js